import './styles.scss'
import React, { useState, useEffect } from 'react'
import { I18n } from 'react-redux-i18n'

import { BrandsAndDelegations, SelectWithLabel } from 'components/Form'
import Tooltip from './Tooltip'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

const Assignment = props => {
  const { label, placeholder, options, value, resetAssignmentInnerValue, onChange, isOperatorField, isRequired, loading, error, getOperatorsOptions } = props
  const [assignmentValue, setAssignmentValue] = useState({})

  useEffect(() => {
    if (resetAssignmentInnerValue > 0) setAssignmentValue({})
  }, [resetAssignmentInnerValue])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && Object.keys(assignmentValue).length) onChange(assignmentValue)
    if (assignmentValue?.brand?.value && assignmentValue?.delegation?.value) {
      getOperatorsOptions({ brands: assignmentValue?.brand?.value, delegations: assignmentValue?.delegation?.value })
    }
    return () => isSubscribed = false
  }, [assignmentValue])

  return (
    <div
      className={`
        smartchat-field assignment
        ${error?.brand ? 'assignment--error-brand' : ''}
        ${error?.delegation ? 'assignment--error-delegation' : ''}
        ${error?.operator ? 'assignment--error-operator' : ''}
      `}
    >
      {label && (
        <div className='smartchat-field__header'>
          {label && <label>{label}</label>}
          <span>{isRequired ? `(${I18n.t('dashboard_required')})` : `(${I18n.t('dashboard_optional')})`}</span>
        </div>
      )}
      <div className='smartchat-field__body'>
        <div className='assignment__fields'>
          <div className='assignment__brands-delegations'>
            <BrandsAndDelegations
              currentBrands={value.brand ? [value.brand] : []}
              onChangeBrands={value => {
                setAssignmentValue(prevState => ({ ...prevState, brand: value, delegation: null }))
              }}
              currentDelegations={value.delegation ? [value.delegation] : []}
              onChangeDelegations={value => {
                setAssignmentValue(prevState => ({ ...prevState, delegation: value }))
              }}
              placeholderBrands={placeholder.brand}
              placeholderDelegations={placeholder.delegation}
              withLabel={false}
              multi={false}
              optionsWithoutAll={true}
              fullWidth={true}
            />
            {[typeof error?.brand, typeof error?.delegation].includes('string') && (
              <Tooltip
                icon={getStaticImage('/icons/orange-brand/icon-warning-yellow.svg')}
                message={error?.brand || error?.delegation}
              />
            )}
          </div>
          {isOperatorField && (
            <div className='assignment__operator'>
              <SelectWithLabel
                placeholder={!loading ? placeholder.operator : null}
                options={options}
                value={value.operator}
                onChange={value => setAssignmentValue(prevState => ({ ...prevState, operator: value }))}
                classNameWrapper='operator'
                fullWidth
              />
              {loading && <Nixi1Spinner width='30px' height='30px' />}
              {!loading && typeof error?.operator === 'string' && (
                <Tooltip
                  icon={getStaticImage('/icons/orange-brand/icon-warning-yellow.svg')}
                  message={error?.operator}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Assignment
